import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import HeroSection from '../components/HeroSection';
import HowItWorks from '../components/HowItWorks';
import WhoWeServe from '../components/WhoWeServe';
import WhyOneLedger from '../components/WhyOneLedger';
import AnimatedSection from '../components/AnimatedSection';
import LearnMoreArrowIcon from '../components/LearnMoreArrowIcon';
import './Home.scss';

export default function Home() {
  return (
    <>
      <Navbar dark />
      <main>
        <HeroSection />
        <HowItWorks />
        <WhoWeServe />
        <WhyOneLedger />
        <CtaBanner />
      </main>
      <Footer />
    </>
  );
}

function CtaBanner() {
  return (
    <section className="cta-banner">
      <div className="container">
        <AnimatedSection className="cta-banner__inner">
          <p className="cta-banner__label">Early Access</p>
          <h2 className="cta-banner__title">
            We're in early conversations with traders,<br />
            brokers and partners across Africa.
          </h2>
          <p className="cta-banner__sub">
            If you trade, finance, or advise on credit across African corridors, we would like to hear from you.
          </p>
          <Link to="/contact" className="btn-learn-more">
            Get In Touch
            <LearnMoreArrowIcon />
          </Link>
        </AnimatedSection>
      </div>
    </section>
  );
}
